export const collections = {
    users: 'Users',
    calcs: 'Calculations',
    fields: 'Fields',
    items: 'Items',
    photos: 'Photos'
}